import { useSSE as e } from "@maat/store-sse";
//#region src/hooks/useChatSSEStatus.ts
var t = () => {
	let { getStatus: t } = e();
	return t("chat");
};
//#endregion
export { t as useChatSSEStatus };
